import {useBreakpointDown} from '@travel-frontend/core';

import {Image} from '@/components/ImageGalleryMosaic/components/Image';
import {List} from '@/components/ImageGalleryMosaic/components/List';
import {Tile} from '@/components/ImageGalleryMosaic/components/Tile';

type Props = {
  images: Array<string>;
};

export const ImageGalleryMosaic: React.FunctionComponent<Props> = ({
  images,
}) => {
  const smDown = useBreakpointDown('sm');

  return (
    <List>
      {images.map((image, index) => {
        const isLarge = index % 3 === 0;

        let width = 50;
        if (smDown || isLarge) {
          width = 100;
        }

        let height = 200;
        if (!smDown && isLarge) {
          height = 400;
        }

        return (
          <Tile key={image} width={width} height={height}>
            <Image src={image} alt="" />
          </Tile>
        );
      })}
    </List>
  );
};
